// extracted by mini-css-extract-plugin
module.exports = {"icon":"GoogleButton_icon__VzFsJ","google-button":"GoogleButton_google-button__8TTNz"};